export interface TextComponentTheme {
  backgroundColor?: string;
  textColor?: string;
  fontWeight?: number;
  fontSize?: string;
}

export const textComponentThemes: Record<string, TextComponentTheme> = {
  board_description: {
    backgroundColor: '#04ceff',
    textColor: '#ffffff',
    fontWeight: 600,
  },
  votes_available: {
    fontSize: '1rem',
    textColor: '#022b3a',
    fontWeight: 600,
  },
  votes_unavailable: {
    textColor: '#9ca3af',
  },
};
